import { Spinner } from "@heroui/react";
import { ButtonGradient } from "@/components/ButtonGradient";
import { useRunCalc } from "@/hooks/useRunCalc";
import { Clients } from "@/lib/clients";
import { useTranslation } from "react-i18next";

const S3RecalculateButton = () => {
  const { t } = useTranslation();
  const runCalcMutation = useRunCalc({ client: Clients.S3 });

  const isSubmitting = runCalcMutation.isPending;

  const handleRecalculate = async () => {
    try {
      await runCalcMutation.mutateAsync();
    } catch (err) {
      console.error("Recalculation failed", err);
    }
  };

  return (
    <ButtonGradient
      onPress={handleRecalculate}
      color="purple"
      isDisabled={isSubmitting}
      startContent={isSubmitting ? <Spinner size="sm" color="primary" /> : null}
    >
      {isSubmitting ? t("recalculate.loading") : t("recalculate.action")}
    </ButtonGradient>
  );
};

export default S3RecalculateButton;
